<template>
  <BaseWarning>
    <i18n :path="warningPath">
      <template #inPitchArea>{{ pitchAreaPath }}</template>
      <template #responsibility>
        <a 
          :href="URLs[data.pitchArea]" 
          target="_blank">
          {{ $t(`tactics.responsibilities.${data.responsibility}`) }}
        </a>
      </template>
      <template #caveat v-if="this.data.caveats !== false">
        {{ caveatString }}
      </template>
    </i18n>
  </BaseWarning>
</template>

<script>
import { ATYPICALLY, PERFORMS } from '../assets/js/tactics/pitch/responsibilities';
import BaseWarning from './BaseWarning'

export default {
  name: 'WarningResponsibilities',

  props: ['data'],

  components: { BaseWarning },

  data: function() {
    return {
      URLs: {
        centralAttack: "https://www.guidetofm.com/tactics/choosing-roles-duties/5/#positional-responsibilities-4",
        centralDefence: "https://www.guidetofm.com/tactics/choosing-roles-duties/2/#positional-responsibilities",
        centralMidfield: "https://www.guidetofm.com/tactics/choosing-roles-duties/3/#positional-responsibilities-2",
        leftFlank: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#positional-responsibilities-3",
        rightFlank: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#positional-responsibilities-3"
      }
    }
  },
  
  computed: {
    warningPath: function() {
      if (!this.data.caveats) {
        return "warnings.responsibilities.baseWarning";
      }
      return "warnings.responsibilities.caveatWarning";
    },
    
    pitchAreaPath: function() {
      return this.$t(`tactics.pitchAreas.in${this.data.pitchArea.charAt(0).toUpperCase() + this.data.pitchArea.slice(1)}`);
    },

    caveatString: function() {
      if (!this.data.caveats) return null;
      if (this.data.caveats.length === 1) {
        return fetchCaveatString(this.data.caveats[0]);
      }
      return this.$t(
        `warnings.responsibilities.join${this.data.caveats.length}Caveats`,
        this.data.caveats.map(fetchCaveatString)
      );

      function fetchCaveatString(caveat) {
        const atypical = caveat.caveat === ATYPICALLY ? 'atypical' : 'vacates';
        const performer = caveat.performance === PERFORMS ? 'Performer' : 'Contributer';
        return this.$t(`warnings.responsibilities.${atypical}${performer}Caveat`, caveat.count);
      }
    }
  }
}
</script>
